<template>
  <div v-if="holidayList">
    <h1>Holiday list</h1>
    <v-alert
      :value="true"
      type="info"
    >Listed below are holiday counts for the selected year. Click the entity to view, change and delete holidays.</v-alert>
    <div>
      <a @click="year = holidayList.previousYear">{{holidayList.previousYear}}</a>
      <span>&#160;</span>
      <span class="holidayYear">{{holidayList.year}}</span>
      <span>&#160;</span>
      <a @click="year = holidayList.nextYear">{{holidayList.nextYear}}</a>
      <span>&#160;</span>
      <v-btn
        v-if="$keycloak.hasRealmRole('holidayadmin')"
        :to="{name:'holidayAdd'}"
        color="success"
        small
      >
        <v-icon>add</v-icon>Holiday
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="computedHolidayList.holidayListItems"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>
          <HolidayEntity :entity="props.item.entity" format="index" v-if="holidaysEntities" />
          <span v-if="!holidaysEntities">{{props.item.id}}</span>
        </td>
        <td class="holidayListCount">{{props.item.total}}</td>
      </template>
      <template v-slot:footer>
        <td>
          <strong>Total</strong>
        </td>
        <td class="holidayListCount">
          <strong>{{computedHolidayList.total}}</strong>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import HolidayEntity from "@/components/link/HolidayEntity";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "HolidayList",
  metaInfo() {
    return {
      title: "Holiday list",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { HolidayEntity },
  computed: {
    computedHolidayList() {
      if (!this.holidayList) {
        return undefined;
      }
      const holidayListItems = this.holidayList.holidayListItems.map(i => {
        const entity = this.holidaysEntities
          ? this.holidaysEntities[i.id]
          : undefined;
        return { ...i, entity };
      });
      const holidayList = { ...this.holidayList, holidayListItems };
      // console.log(holidayList);
      return holidayList;
    }
  },
  data() {
    return {
      year: null,
      holidayList: null,
      holidaysEntities: null,
      headers: [
        {
          text: "conveyancer",
          sortable: false
        },
        {
          text: "days",
          value: "total",
          align: "right"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchHolidayList() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/list`, {
          params: { year: this.year }
        })
        .then(response => {
          // console.log(response.data);
          this.holidayList = response.data;
        })
        .catch(() => {});
    },
    fetchHolidaysEntities() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/entities`, {
          params: { year: this.year }
        })
        .then(response => {
          // console.log(response.data);
          this.holidaysEntities = response.data;
        })
        .catch(() => {});
    },
    update() {
      this.fetchHolidayList();
      this.fetchHolidaysEntities();
    }
  },
  watch: {
    year: {
      immediate: true,
      handler() {
        this.update();
      }
    }
  }
};
</script>


<style scoped>
.holidayListCount {
  text-align: right;
}
.holidayYear {
  font-size: 1.5em;
  font-weight: bold;
}
</style>